import { useSegments } from 'expo-router';

/**
 * Safely wraps `useSegments` from `expo-router`.
 *
 * Returns `null` when called outside an `expo-router` context.
 */
export const useSafeSegments = () => {
  try {
    return useSegments();
  } catch {
    return null;
  }
};
